import React from 'react';
import classes from './Collection.css';
import Aux from '../../hoc/Aux';
import { NavLink } from 'react-router-dom';

const collection = props => {
    return (
        <Aux>
            <NavLink to={props.link} className={classes.CollectionLink}>
                <img
                    src={props.image}
                    alt={props.title}
                    className="img-fluid"
                />
                <div className={classes.Title}>{props.title}</div>
            </NavLink>
        </Aux>
    );
};

export default collection;



// WEBPACK FOOTER //
// ./src/components/Collection/Collection.js